export default "__VITE_ASSET__Bfueg_yz__"